/* eslint-disable */
// @ts-nocheck
import debugLib from 'debug';
import { ORG_VIEW } from '../../common/support/viewConstants';
type IntercomConfig = {
  email: string;
  name: string;
  OnboardingStep?: string;
};

class Intercom {
  name = 'intercom';

  CUSTOM_LAUNCHER_ID = '#bnc-intercom';

  debug = debugLib('Intercom');

  isIntercomLoaded() {
    return !!window.Intercom;
  }

  initialize(config: IntercomConfig) {
    this.debug('initialize config', config);
    const app_id = window.intercom_id;
    const { email, name, OnboardingStep } = config;
    const hasEnoughInfo = app_id && email && name;

    if (this.isIntercomLoaded() && hasEnoughInfo) {
      const intercomPayload = {
        app_id,
        email,
        name,
        OnboardingStep,
        custom_launcher_selector: this.CUSTOM_LAUNCHER_ID,
        user_id: email,
        ...this.getBranchEntityId(),
      };
      this.debug('Initialize intercom for user', intercomPayload);
      window.Intercom('boot', intercomPayload);
    }
  }

  getBranchEntityId() {
    const { current_view: currentView, app_id: branchAppId, organization_id: branchOrgId } = window.App.context.view;
    this.debug({
      branchOrgId,
      branchAppId,
    });
    return currentView === ORG_VIEW
      ? {
          branchOrgId,
        }
      : {
          branchAppId,
        };
  }

  update(config: IntercomConfig) {
    this.debug('update config', config);
    const { email, name, OnboardingStep } = config;

    if (this.isIntercomLoaded() && email) {
      this.debug('Update intercom for user', email);
      window.Intercom('update', {
        email,
        name,
        OnboardingStep,
        user_id: email,
        ...this.getBranchEntityId(),
      });
    }
  }

  event(eventName: string, data?: Record<string, any>) {
    this.debug('eventName', eventName);

    if (this.isIntercomLoaded() && eventName) {
      window.Intercom('trackEvent', eventName, data);
    }
  }

  /**
   * Logout from Intercom
   */
  logout() {
    if (this.isIntercomLoaded()) {
      this.debug('Close intercom sessions');
      window.Intercom('shutdown');
    }
  }
}

export default Intercom;
